<template>
  <section
    class="tw-mb-8 tw-border-solid tw-border-gp-midnight-2 tw-pb-8 last:tw-border-b-0"
    :class="{
      'tw-border-b-2': border,
    }"
  >
    <h2
      v-if="title != null"
      class="tw-mb-4 tw-text-2xl tw-transition-colors focus:tw-text-gp-cyan"
      ref="section"
      tabindex="-1"
      :id="sectionId"
    >
      {{ title }}
    </h2>
    <slot />
  </section>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref, useTemplateRef } from 'vue';
import Size from '../interfaces/Size';
import { useRoute } from 'vue-router';

export default defineComponent({
  props: {
    size: {
      type: Number,
      default: Size.Large,
    },
    title: {
      type: String,
      default: undefined,
      required: false,
    },
    border: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      S: Size,
    };
  },
  setup(props) {
    const sectionId = computed(() => {
      if (props.title != null) {
        return props.title.toLowerCase().replace(/\s/g, '-');
      }
      return '';
    });

    const highLighting = ref(false);
    const route = useRoute();
    const section = useTemplateRef<HTMLElement>('section');

    onMounted(() => {
      if (route.hash != null && route.hash.length > 0) {
        // clean hash from query (for some reason vue router adds query to hash, this comes when refreshing the page where the page goes to keycloak and back)
        const [cleanedHash] = route.hash.split('&');

        if (cleanedHash.length > 0 && cleanedHash === `#${sectionId.value}`) {
          setTimeout(() => {
            section.value.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });

            section.value.focus();
          }, 2000);
        }
      }
    });

    return {
      section,
      sectionId,
      highLighting,
    };
  },
});
</script>
